
import { mapState } from 'vuex'
import vueTelegramLogin from './vue-telegram-login.vue'
export default {
  components: {
    'vue-telegram-login': vueTelegramLogin
  },
  props: {
    isState: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      // icon: [ // 测试用
      //   { icon: require('../../assets/img/login/Wechat.svg'), type: 1, url: null },
      //   { icon: require('../../assets/img/login/Facebook.svg'), type: 2, url: null },
      //   { icon: require('../../assets/img/login/Google.svg'), type: 3 },
      //   { icon: require('../../assets/img/login/AppleID.svg'), type: 4 },
      //   { icon: require('../../assets/img/login/Telegram.svg'), type: 7 },
      //   { icon: require('../../assets/img/login/Linkedin.svg'), type: 8 }
      // ],
      clientId: '720725194691-5mlhk8dgsc12gg9409g8bthqhhras28p.apps.googleusercontent.com',
      googleBtnConfigs: {
        type: 'icon',
        shape: 'rectangular',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        locale: 'es-419',
        logo_alignment: 'center',
        width: 400
        // locale: "zh_CN"
      }
    }
  },
  computed: {
    ...mapState(['myCountry', 'host', 'userlogin2', 'LanguageCode']),
    telegramId() {
      if (this.host.includes('broker.wikifx.com')) {
        return 'wikibroker_bot'
      } else if (this.host.includes('info.wikifx.com')) {
        return 'wikifxinfo_bot'
      } else {
        return 'wikibroker_bot'
      }
    },
    icon() {
      const isCn = this.myCountry === 'cn'
      const validHosts = ['wikifx.hk', 'fxeyetips.ps', 'localhost', '192.168.19.34']
      const Hosts = ['wikifx.com', 'localhost', '192.168.19.34']
      const cnHost = ['wikifx.com', 'wikifx.hk', 'fxeyetips.ps', 'localhost', '192.168.19.34']
      // 基础图标列表
      const baseIcons = [
        { icon: require('../../assets/img/login/Wechat.svg'), type: 1 },
        { icon: require('../../assets/img/login/Facebook.svg'), type: 2 },
        { icon: require('../../assets/img/login/Google.svg'), type: 3 },
        { icon: require('../../assets/img/login/AppleID.svg'), type: 4 },
        { icon: require('../../assets/img/login/Telegram.svg'), type: 7 },
        { icon: require('../../assets/img/login/Linkedin.svg'), type: 8 }
      ]
      // 1微信;2Facebook,3Google,4苹果,7电报,8领英
      // 国内特殊站点=>124  cnHost 给了谷歌和苹果权限
      // 国内其他站点=>18
      // 以下国外
      // wikifx.com 有123478
      // 特殊站点有 12348   validHosts 没有wikifx.com
      // 其他的站点有 18

      let icons = []
      if (isCn) {
        if (cnHost.some((host) => this.host.includes(host))) {
          icons = baseIcons.filter((icon) => icon.type === 1 || icon.type === 2 || icon.type === 4)
          console.log('国内特殊')
        } else {
          icons = baseIcons.filter((icon) => icon.type === 1)
          console.log('国内其他')
        }
      } else if (!isCn) {
        // 国外
        if (Hosts.some((host) => this.host.includes(host))) {
          console.log('显示全部')
          icons = baseIcons
        } else if (validHosts.some((host) => this.host.includes(host))) {
          icons = baseIcons.filter((icon) => icon.type !== 7)
          console.log('国外不要7')
        } else {
          icons = baseIcons.filter((icon) => icon.type === 1 || icon.type === 8)
          console.log('国外只要18')
        }
      }
      return icons
    }
  },
  created() {},
  mounted() {
    if (this.isState == 1) this.getTripartite() // 获取三方地址
  },
  methods: {
    popmessage(item) {
      console.log('item', item)
      if (item.url && this.userlogin2) {
        const postdata = {
          op_type: 'opennew',
          url: `${item.url}&fromurl=##&middlepage=${`https://${this.host}/${this.LanguageCode}/return.html`}`,
          parm: ''
        }
        window.parent.postMessage(postdata, '*')
      }
    },
    yourCallbackFunction(user) {
      const that = this
      that.$api.usercenter
        .getWaistcoat(
          {
            auth_date: user.auth_date,
            first_name: user.first_name,
            hash: user.hash,
            last_name: user.last_name,
            id: user.id,
            photo_url: user.photo_url ? user.photo_url : ''
          },
          {
            HttpMethod: 'post',
            Route: 'usercenter$telegramcallback'
          }
        )
        .then((res) => {
          that.googleLogin(res)
          console.log('telegram登录', res)
        })
        .catch((err) => {
          console.log(err)
        })
      console.log(user)
    },
    async getTripartite() {
      const getThreparty = await this.$api.common
        .CV3(
          // 获取三方接口
          {},
          {
            Routes: 'usercenter$getfxwechatloginurl'
          }
        )
        .catch(() => {
          console.log('getfxwechatloginurl')
        })
      if (getThreparty && getThreparty.usercenter && getThreparty.usercenter.getfxwechatloginurl) {
        console.log('getThreparty: ', getThreparty)
        this.icon.forEach((item) => {
          getThreparty.usercenter.getfxwechatloginurl.data.forEach((e) => {
            if (item.type == 1 && e.LoginType == 'Wechat') item.url = e.LoginUrl
            if (item.type == 2 && e.LoginType == 'FaceBook') item.url = e.LoginUrl
            if (item.type == 8 && e.LoginType == 'linkedIn') item.url = e.LoginUrl
          })
        })
        console.log('this.icon: ', this.icon)
        this.$forceUpdate() // 强制渲染
      }

      if (this.myCountry != 'cn') {
        // 谷歌
        const googleSignInAPI = document.createElement('script')
        googleSignInAPI.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(googleSignInAPI)
        const _that = this
        googleSignInAPI.onload = function () {
          // InitGoogleButton 初始化登录按钮
          // eslint-disable-next-line no-undef
          google.accounts.id.initialize({
            client_id: _that.clientId,
            callback: _that.OnSuccess
          })

          // eslint-disable-next-line no-undef
          google.accounts.id.renderButton(document.getElementById('google-login-btn'), _that.googleBtnConfigs)
        }
      }

      // applyid
      const applyidSignInAPI = document.createElement('script')
      applyidSignInAPI.setAttribute('src', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')
      document.head.appendChild(applyidSignInAPI)
      const _that = this
      let secondDomain = 'broker'
      if (this.host.includes('info')) {
        secondDomain = 'info'
      }
      applyidSignInAPI.onload = function () {
        // eslint-disable-next-line no-undef
        AppleID.auth.init({
          clientId: 'com.wikifx.web',
          scope: 'name email',
          redirectURI: `https://${secondDomain}${_that.$store.state.cookieHost}`,
          state: 'xcoiv98y2kd22vusuye3kch',
          // nonce : '[NONCE]',
          usePopup: true
        })
      }
      const buttonElement = document.querySelector('.appleid-signin')
      const that = this
      buttonElement &&
        buttonElement.addEventListener(
          'click',
          () => {
            // eslint-disable-next-line no-undef
            AppleID.auth
              .signIn()
              .then(function (data) {
                console.log('1223', data)
                that.$api.usercenter
                  .getWaistcoat(
                    {
                      code: data.authorization.code
                    },
                    {
                      HttpMethod: 'get',
                      Route: 'usercenter$webapplecallback'
                    }
                  )
                  .then((res) => {
                    that.googleLogin(res)
                    console.log('appleid登录', res)
                  })
              })
              .catch(() => {
                console.log('apple')
              })
          },
          { passive: true }
        )
    },
    OnSuccess(resp) {
      this.onGoogleAuthSuccess(resp.credential)
    },
    onGoogleAuthSuccess(jwtCredentials) {
      console.log(jwtCredentials)
      this.$api.common
        .CV3(
          {
            Token: jwtCredentials
          },
          {
            Routes: 'usercenter$googlecallback'
          }
        )
        .then((res) => {
          console.log('res: ', res)
          if (res?.usercenter?.googlecallback?.data) this.googleLogin(res?.usercenter?.googlecallback?.data)
        })
    },
    googleLogin(res) {
      if (res.isRegister) {
        this.$nextTick(() => {
          this.setCookie(res.cookieValue)
        })
      } else {
        setTimeout(() => {
          if (process.client) {
            const href = window.location.href.substr(0, window.location.href.indexOf('?')) ? window.location.href.substr(0, window.location.href.indexOf('?')) : window.location.href
            const ulr = `?type=register&id=${res.id}&name=${res.nickName}&img=${res.img}&logintype=${res.loginType}&email=${res.email ? res.email : null}&returnurl=${href}`
            // console.log('`https:', `https://${this.host}/${this.LanguageCode}/login.html${ulr}`)
            window.location.href = `//${this.host}/${this.LanguageCode}/userlogin.html${ulr}`
            // console.log('`//${thi', `//${this.host}/${this.LanguageCode}/login.html${ulr}`)
          }
        }, 500)
      }
    },
    setCookie(cookievalue) {
      this.$store.commit('loginClose', false)
      if (cookievalue) {
        this.$api.home.clientgetUsercookie({ contentcookie: cookievalue }).then((res) => {
          // 主账号信息
          this.$store.commit('setUser', {
            userId: res.result.userId,
            nick: res.result.nick,
            avatar: res.result.avatar,
            vest: false // 是否为马甲号
          })
        })
      }
      if (this.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', cookievalue, `.${this.host.split('.')[1]}.com`)
      } else if (this.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', cookievalue, `.${this.host.split('.')[1]}.com`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', cookievalue)
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: cookievalue
        }
        window.parent.postMessage(postdata, '*')
      }
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: ''
      }
      window.parent && window.parent.postMessage(postdata, '*')
      this.$store.commit('setUsercookie', cookievalue)
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
